import React from "react";

import Button from "@mui/material/Button";
import styled from "@mui/material/styles/styled";
import Typography, { TypographyProps } from "@mui/material/Typography";

import ROUTES from "@app/common/routes";

import { Link } from "@rui/Link";
import LoadSpinner from "@rui/LoadSpinner";
import Stack, { Row, StackProps } from "@rui/Stack";

export const Container = styled(Stack)(({ theme }) => ({
  width: "100%",
  height: "100vh",
  background: theme.palette.gradients.light,
  padding: 0,
  [theme.breakpoints.up("xs")]: {
    padding: theme.spacing(2),
  },
  [theme.breakpoints.up("sm")]: {
    padding: "40px",
  },
}));

export const Card = styled(Stack)(({ theme }) => ({
  backgroundColor: "#FFF",
  borderRadius: "4px",
  padding: theme.spacing(1),
  width: "600px",
  maxWidth: "100%",
  maxHeight: "100%",
  [theme.breakpoints.down("xs")]: {
    minHeight: "100%",
  },
  [theme.breakpoints.up("xs")]: {
    padding: theme.spacing(2),
    boxShadow: "0px 0px 16px 0px #0000001A",
    border: "1px solid #00000014",
  },
}));

export const Header = styled(Row)(({ theme }) => ({
  padding: theme.spacing(0, 0.5, 0.5),
  borderBottom: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  marginBottom: theme.spacing(2),
  minHeight: "60px",
  [theme.breakpoints.down("xs")]: {
    "& .daily-read__button--extra-text": {
      display: "none",
    },
  },
  [theme.breakpoints.up("xs")]: {
    padding: theme.spacing(0, 2, 1),
  },
}));

export const TranscriptBlock = styled(Stack)(({ theme }) => ({
  borderRadius: "8px",
  border: "1px solid",
  borderColor: theme.palette.shades.neutral[100],
  overflow: "hidden",
}));

export const TranscriptScrollContainer = styled(Stack)(({ theme }) => ({
  overflowY: "auto",
  padding: theme.spacing(2),
}));

export const Loading = styled<React.FC<StackProps>>((props) => (
  <Stack variant="center" {...props}>
    <LoadSpinner />
  </Stack>
))({
  height: "178px",
  maxHeight: "100%",
});

export const EmptyText = styled<React.FC<TypographyProps>>((props) => (
  <Typography variant="bodySecondaryReg" {...props} />
))(({ theme }) => ({
  color: theme.palette.shades.neutral[600],
  textAlign: "center",
}));

export const MessageContainer = styled(Stack)(({ theme }) => ({
  flexDirection: "column",
  borderRadius: "8px",
  backgroundColor: theme.palette.shades.secondary[100],
  padding: theme.spacing(1, 2),
  color: theme.palette.shades.neutral[600],
  [theme.breakpoints.up("sm")]: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
}));

export const AddReadButton = styled((props) => (
  <Link to={ROUTES.CALENDAR_UPCOMING}>
    <Button {...props} variant="contained">
      Add Read
    </Button>
  </Link>
))(({ theme }) => ({
  whiteSpace: "nowrap",
  color: "#FFF",
  backgroundColor: theme.palette.shades.secondary[400],
  boxShadow: "none",
  padding: "6px 8px",
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: theme.palette.shades.secondary[500],
  },
}));
